import React from "react";
import {
  CheckCircleIcon,
  XCircleIcon,
} from "@heroicons/react/24/solid";
import { comparisonCategories } from "./pricingData";

export default function PricingCompare() {
  return (
    <section className="py-[100px] px-6 lg:px-10 bg-base-white">
      <div className="max-w-[900px] mx-auto">
        <div className="text-center mb-12 fade-in">
          <h2 className="font-inter text-[24px] sm:text-[32px] lg:text-[38px] font-black tracking-[-1.5px] leading-[1.15] mb-4">
            Compare Plans
          </h2>
          <p className="font-inter text-base text-gray-cool-500 leading-[1.7] max-w-[600px] mx-auto">
            See exactly what&apos;s included in each plan so you can choose with
            confidence.
          </p>
        </div>

        <div className="fade-in overflow-x-auto">
          <table className="w-full min-w-[600px]">
            {/* Header */}
            <thead>
              <tr className="bg-blue-primary-900 text-white">
                <th className="text-left font-inter text-[14px] font-semibold py-4 px-6 rounded-tl-xl">
                  Features
                </th>
                <th className="text-center font-inter text-[14px] font-semibold py-4 px-6 w-[140px]">
                  Essentials
                </th>
                <th className="text-center font-inter text-[14px] font-semibold py-4 px-6 w-[140px] rounded-tr-xl">
                  Complete
                </th>
              </tr>
            </thead>
            <tbody>
              {comparisonCategories.map((category, catIdx) => (
                <React.Fragment key={catIdx}>
                  {/* Category header */}
                  <tr>
                    <td
                      colSpan={3}
                      className="font-inter text-[12px] font-bold uppercase tracking-[1px] text-gray-cool-500 pt-6 pb-3 px-6 border-b border-gray-cool-200"
                    >
                      {category.name}
                    </td>
                  </tr>
                  {/* Features */}
                  {category.features.map((feature, idx) => (
                    <tr
                      key={`${catIdx}-${idx}`}
                      className="border-b border-gray-cool-100 hover:bg-gray-cool-50 transition-colors"
                    >
                      <td className="font-inter text-[14px] text-gray-cool-700 py-4 px-6">
                        {feature.name}
                      </td>
                      <td className="text-center py-4 px-6">
                        {feature.essentials ? (
                          <CheckCircleIcon className="w-5 h-5 text-green-500 mx-auto" />
                        ) : (
                          <XCircleIcon className="w-5 h-5 text-gray-cool-300 mx-auto" />
                        )}
                      </td>
                      <td className="text-center py-4 px-6">
                        {feature.complete ? (
                          <CheckCircleIcon className="w-5 h-5 text-green-500 mx-auto" />
                        ) : (
                          <XCircleIcon className="w-5 h-5 text-gray-cool-300 mx-auto" />
                        )}
                      </td>
                    </tr>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
